// GovWellRequestHeaders is duplicated on the BE
export enum GovWellRequestHeaders {
  TimeZone = 'X-Govwell-Time-Zone',
}
